module.exports = __webpack_public_path__ + "img/ellipse-gif.93c3316b.png";